import { useEffect, useRef } from 'react';

// Calls `save` `delay` ms after the most recent tracked change, as long as
// there are still unsaved changes when the timer fires. The timer restarts
// on every `changeToken` change, so a burst of edits (e.g. dragging a room)
// only triggers one save, shortly after the user stops.
export function useAutoSave({ isDirty, changeToken, save, delay = 1500, enabled = true }) {
  const saveRef = useRef(save);
  saveRef.current = save;

  useEffect(() => {
    if (!enabled || !isDirty) return;
    const timer = setTimeout(() => { saveRef.current(); }, delay);
    return () => clearTimeout(timer);
  }, [changeToken, isDirty, delay, enabled]);
}
